import apiResource from '@/services/http/api/resource'

export default {
  namespaced: true,
  state: {
    loader: null
  },
  getters: {
    getLoader: (state) => state.loader
  },
  mutations: {
    setLoader(state, payload) {
      state.loader = payload
    }
  },
  actions: {
    postDonor(context, payload) {
      context.commit('setLoader', true)
      return apiResource
        .postDonor(payload)
        .then(({ data }) => {
          return data.data
        })
        .finally(() => {
          context.commit('setLoader', false)
        })
    }
  }
}
